import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import PostForm from './PostForm';
import CategoryPanel from '../categories/categoryPanel'
import { Container } from 'components';
import { TagPanel } from '../';
import * as Api from 'api';
import * as Actions from 'actions';

class CreatePostContainer extends React.Component {
  constructor(props) {
    super(props);
    this.handlePostCreate = this.handlePostCreate.bind(this);
    this.handlePostCreated = this.handlePostCreated.bind(this);
    this.displayName = 'CreatePostContainer';
  }
  handlePostCreate(post) {
  	if(!post) {
      return;
    }

	  Api
    .savePost(post)
    .then(this.handlePostCreated)
    .catch(e => this.props.notify({message : e.message, title: 'Error Saving Post!'}));
  }
  handlePostCreated(res) {
		this.props.history.push('/posts/');
  }
  componentWillMount() {
    if(!this.props.hasPermission('/Post/Create/')) {
      this.context.router.goBack();
    }
  }
  render() {
    return(
    	<Container title='Create Post'>
        <div className="col-md-8">
          <PostForm heading="Create Post" handleSave={this.handlePostCreate} />
        </div>
        <div className="col-md-4">
          <CategoryPanel />
          <TagPanel />
        </div>
      </Container>
    );
  }
}

CreatePostContainer.contextTypes = {
    router : PropTypes.object
}

var mapStateToProps = function(state) {
    return { connection : state.connection };
}

export default connect(mapStateToProps, Actions)(CreatePostContainer);



// WEBPACK FOOTER //
// ./src/browser/components/posts/createPostContainer.js